// extracted by mini-css-extract-plugin
module.exports = {"stop-process-container":"_22Ny_","stop-process":"_3goWE","stop":"_14eUN","description":"_2wv-H","input-box":"_3ph7W","subcribe-bottom":"_1UZO6"};